var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGytWorkz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3323 0.219192L12.0184 0C8.95929 0 6.55566 2.41096 6.55566 5.47944C6.55566 8.54792 8.95929 10.9589 12.0184 10.9589H33.8695V32.8766C33.8695 35.9453 36.2732 38.356 39.3323 38.356C40.8619 38.356 42.173 37.6985 43.2658 36.8218C44.3581 35.7257 44.7951 34.4106 45.0136 32.8766L44.7951 5.69863C44.7951 2.6303 42.3915 0.219192 39.3323 0.219192Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4141 18.1932H5.46278C2.40363 18.1932 0 20.6042 0 23.6727C0 26.7412 2.40363 29.1521 5.46278 29.1521H15.9513V39.6726C15.9513 42.7413 18.3549 45.1521 21.4141 45.1521C22.9437 45.1521 24.2547 44.4945 25.3473 43.6178C26.4399 42.5219 26.8769 41.2069 27.0955 39.6726V23.6727C26.8769 20.6042 24.4732 18.1932 21.4141 18.1932Z",
    fill: "url(#paint1_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 4.55585,
    y1: 44.5697,
    x2: 25.5649,
    y2: 19.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#E84D15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#E84A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#E84531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#E83E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#E8355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#E7246D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6007E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 3.35984,
    y1: 43.5345,
    x2: 24.3143,
    y2: 18.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#E84D15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#E84A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#E84531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#E83E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#E8355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#E7246D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6007E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGytWorkz);
export default __webpack_public_path__ + "static/media/GytWorkz.f355c9dd4a0f07f695e4473d775eaf39.svg";
export { ForwardRef as ReactComponent };